import { render, staticRenderFns } from "./StargateLog.vue?vue&type=template&id=0fd53f0f&scoped=true"
import script from "./StargateLog.vue?vue&type=script&lang=js"
export * from "./StargateLog.vue?vue&type=script&lang=js"
import style0 from "./StargateLog.vue?vue&type=style&index=0&id=0fd53f0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd53f0f",
  null
  
)

export default component.exports